import RESTClient from 'web-app/api/clients/rest-client-famly-app';

import * as Helpers from './helpers';
import type * as Types from './types';

export const fetch = () =>
    RESTClient.getAuthenticatedObservable('v2/notificationsettings/notificationHours').map(
        ({notificationHours, show}) => {
            return {
                formData: Helpers.fromAPI(notificationHours),
                show,
            };
        },
    );

export const update = (data: Types.FormData) =>
    RESTClient.postAuthenticatedObservable('v2/notificationsettings/notificationHours', Helpers.toAPI(data)).map(
        ({notificationHours}) => Helpers.fromAPI(notificationHours),
    );

export const fetchTimezones = () =>
    RESTClient.getAuthenticatedObservable('v2/time-zones').map(({timeZones}) =>
        timeZones.map(timezone => ({
            value: timezone,
            label: timezone,
        })),
    );
